import { useRCAHistoryMainStyles } from "../../RCA.styles";
import { RCAUserHistoric } from "./RCAUserHistoric";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export const RCAUserChangeLog = ({ newValue, oldValue }: { newValue: string | null; oldValue: string | null }) => {
    const classes = useRCAHistoryMainStyles();

    return (
        <div className={classes.historyChangeWrapper}>
            <RCAUserHistoric userId={Number(oldValue)} />
            <ArrowForwardIcon />
            <RCAUserHistoric userId={Number(newValue)} />
        </div>
    );
};
